import React, {Suspense, useEffect, useRef} from 'react';
import {Bounds, Center, ContactShadows, Float, OrbitControls, useAnimations, useGLTF} from '@react-three/drei';
import BackgroundSphere from 'components/webgl/BackgroundSphere';
import {animationStore} from 'stores/animationStore';
import {usePlayAnimations} from 'hooks/usePlayAnimations';
import {useFrame} from '@react-three/fiber';
import CameraControls from 'components/webgl/CameraControls';

const Scene = () => {
  const setSceneAnimations = animationStore(state => state.setSceneAnimations);

  const gltf = useGLTF('./montre_eclatee.glb');

  const {actions} = useAnimations(gltf.animations, gltf.scene);
  usePlayAnimations(gltf.scene, actions);
  useEffect(() => {
    if (gltf?.animations)
      setSceneAnimations(gltf.animations);
  }, [gltf, setSceneAnimations]);


  return (
    <Suspense fallback={null}>
      {/*<OrbitControls ref={orbitRef} makeDefault minDistance={1} maxDistance={4} maxPolarAngle={Math.PI / 2}/>*/}
      <CameraControls/>
      <BackgroundSphere/>

      <Float>
        <Bounds fit clip damping={8} margin={1.2}>
          <Center>
            <primitive object={gltf.scene}/>

          </Center>
        </Bounds>
      </Float>

      <ContactShadows rotation-x={Math.PI / 2} position={[0, -2, 0]} opacity={.9} width={10} height={10} blur={4}
                      far={2}/>
    </Suspense>
  );
};

export default Scene;